/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AuthenticatedTemplate, useMsal } from '@azure/msal-react';
export var LoginLogoutToolbarItem = function () {
    var instance = useMsal().instance;
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        React.createElement(AuthenticatedTemplate, null,
            React.createElement("a", { className: 'sdds-nav__avatar-item-core', role: "button", onClick: function () { return instance.logout(); } }, t("TS_core:Logout")))));
};
export default LoginLogoutToolbarItem;
